export function ocultarEmail(email: string): string {
    const [usuario, dominio] = email.split('@');

    if (usuario.length < 3) {
        return "Nome de usuário muito curto.";
    }

    const caracteresParaOcultarUsuario = Math.floor(usuario.length / 3);

    const regexUsuario = new RegExp(`(?<=.{${caracteresParaOcultarUsuario}}).(?=.{${caracteresParaOcultarUsuario}})`, 'g');

    const usuarioOculto = usuario.replace(regexUsuario, '*');

    const dominioOculto = email.includes(' ') ? '' : dominio.replace(/(.)(?=[^@]*\.)/g, '*');

    return `${usuarioOculto}@${dominioOculto}`;
}